import React, { useEffect, useState } from 'react'
import { Button, Col, Modal, Row } from 'react-bootstrap'
import MightyDealsIcon from '../app/styles/components/MightyDealsIcon'
import AutoshipICon from '../app/styles/components/AutoshipICon'
import DeadLineReminderIcon from '../app/styles/components/DeadLineReminderIcon'
import EarnRewardsIcon from '../app/styles/components/EarnRewardsIcon'
import '../pages/ThankyouPageOffers.scss';
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { selectGeneralOptions, selectIsMobileRoute } from '../features/mobile/mobileSlice'
import { selectOrderPlannerOrders } from './AutoshipPages/core/orderPlannerOrdersSlice'
import OrderObj from '../features/orders/orderObj'

interface Props {
    order: OrderObj | null;
}

export default function ThankyouPageOffers({ order }: Props) {
    const navigate = useNavigate();
    const AppURL = useSelector(selectIsMobileRoute);
    const orderPlannerOrders: Array<Record<string, any>> = useSelector(selectOrderPlannerOrders);
    const getGeneralOptions = useSelector(selectGeneralOptions);
    const [icsFilePath, setICSFilePath] = useState('');
    const [deadLineBox, setDeadLineBox] = useState(false);
    const QURLParams = AppURL ? `/?${AppURL}` : '/';
    const AndURLParams = AppURL ? `&${AppURL}` : '';
    const plannedOrders = orderPlannerOrders.filter((order: any) => {
        return order.status === 'autoship' || order.status === 'autoship-onhold';
    });

    useEffect(() => {
        async function fetchData() {
            try {
                if (getGeneralOptions) {
                    if (getGeneralOptions.ics_file_path) {
                        setICSFilePath(getGeneralOptions.ics_file_path);
                    }
                }
            } catch (error) {
                console.error(error);
            }
        }
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleAutoshipIconClick = () => {
        if (plannedOrders.length > 0) {
            navigate(`/autoship${QURLParams}`);
        } else {
            navigate(`/autoship?start=true${AndURLParams}`);
        }
    }

    return (
        <div className='d-flex justify-content-center align-items-center'>
            <Modal show={deadLineBox} centered onHide={() => setDeadLineBox(false)}>
                <Modal.Header className='border-bottom-0 pb-0' closeButton>
                </Modal.Header>
                <Modal.Body className='pt-0'>
                    <div className='text-center'>
                        <div className='font-league-gothic fs-35px me-2 font-barlow'>Never Miss a Deadline!</div>
                        <div className='fs-6 mb-3'>Add an order deadline reminder to your calendar.</div>
                        <Button
                            className='bg-black font-league-gothic text-inherit fs-23px mt-0 m-3'
                            size="lg"
                            disabled={icsFilePath?.length === 0 ? true : false}
                            onClick={() => {
                                window.open(`${icsFilePath}`);
                            }}
                        >
                            Apple / Outlook
                        </Button>
                        <Button
                            className='bg-black font-league-gothic text-inherit fs-23px mt-0 m-3'
                            size="lg"
                            onClick={() => {
                                let deliveryDate = order?.getFullDeliveryDate();
                                if (deliveryDate) {
                                    const startDate = new Date(deliveryDate);
                                    const endDate = new Date(deliveryDate);
                                    endDate.setMinutes(endDate.getMinutes() + 15);
                                    const formattedStartDate = startDate.toISOString().replace(/[:-]/g, '');
                                    const formattedEndDate = endDate.toISOString().replace(/[:-]/g, '');
                                    const calendarUrl = `https://calendar.google.com/calendar/u/0/r/eventedit?dates=${formattedStartDate}/${formattedEndDate}&details=%F0%9F%9A%9A+Order+Deadline+is+Tonight+at+Midnight!+https://mightymeals.com/order%0A%F0%9F%93%9E+Order+with+an+expert+who+can+help+(833)+40+MEALS&text=MightyMeals+Deadline!&recur=RRULE:FREQ=WEEKLY;BYDAY=Mo,Th`;

                                    window.open(calendarUrl);
                                }
                            }}
                        >
                            Google Calendar
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>
            <Row className="gy-4 d-flex align-items-center text-center offerswrapp">
                <Col>
                    <div
                        onClick={() => navigate(`/mightydeals${QURLParams}`)}
                        className="d-flex justify-content-center mb-2 svg-icon mightydealsIcon"
                    >
                        <MightyDealsIcon />
                    </div>
                    <div>
                        <span className="fw-medium icon-text font-barlow">MightyDeals & Savings</span>
                    </div>
                </Col>
                <Col>
                    <div
                        onClick={handleAutoshipIconClick}
                        className="d-flex justify-content-center mb-2 svg-icon autoshipIcon"
                    >
                        <AutoshipICon />
                    </div>
                    <div>
                        <span className="fw-medium icon-text font-barlow">Plan Your Next Order</span>
                    </div>
                </Col>
                <Col>
                    <div
                        onClick={() => setDeadLineBox(true)}
                        className="d-flex justify-content-center mb-2 position-relative deadlineIcon svg-icon"
                    >
                        <DeadLineReminderIcon />
                    </div>
                    <div>
                        <span className="fw-medium icon-text font-barlow">Deadline Reminder</span>
                    </div>
                </Col>
                <Col>
                    <div
                        onClick={() => navigate(`/my-account/mightypoints${QURLParams}`)}
                        className="d-flex justify-content-center mb-2 earnrewardsIcon svg-icon"
                    >
                        <EarnRewardsIcon />
                    </div>
                    <div>
                        <span className="fw-medium icon-text font-barlow">Earn more Rewards</span>
                    </div>
                </Col>
            </Row>
        </div>
    )
}
